import { render, staticRenderFns } from "./MySupport.vue?vue&type=template&id=71265390&scoped=true"
import script from "./MySupport.vue?vue&type=script&lang=js"
export * from "./MySupport.vue?vue&type=script&lang=js"
import style0 from "./MySupport.vue?vue&type=style&index=0&id=71265390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71265390",
  null
  
)

export default component.exports